"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const FormHelperText_1 = __importDefault(require("@mui/material/FormHelperText"));
const koden_koden_text_field_1 = require("@scott/koden.koden-text-field");
const DialogColumns = ({ columns, disabled, dirty, errors, errorMsg, stateMap, setStateMap, }) => {
    return (React.createElement(React.Fragment, null,
        columns.map((column) => {
            const { id, label, autoFocus, placeholder } = column;
            const value = stateMap[id];
            const error = !dirty ? "" : errors[id];
            return (React.createElement(koden_koden_text_field_1.KodenTextField, { key: id, id: id, readOnly: false, label: label, autoFocus: autoFocus, placeholder: placeholder, disabled: disabled, value: value, error: error, onChange: (value) => {
                    setStateMap((map) => {
                        return Object.assign(Object.assign({}, map), { [id]: value });
                    });
                } }));
        }),
        React.createElement(FormHelperText_1.default, { error: errorMsg !== "" }, errorMsg)));
};
exports.default = DialogColumns;
//# sourceMappingURL=DialogColumns.js.map